<template>
  <div>
    <b-tabs v-model="tabIndex">
      <b-tab title="List View"><list-view v-if="tabIndex === 0"/></b-tab>
      <b-tab title="Matrix View"><matrix-view v-if="tabIndex === 1"/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import ListView from './PaymentOption/VIPLevelPaymentListView'
import MatrixView from './PaymentOption/VIPLevelPaymentMatrixView'
export default {
  name: 'vip-payment-options',
  data () {
    return {
      tabIndex: 0
    }
  },
  components: {
    ListView,
    MatrixView
  }
}
</script>


// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelPaymentTable.vue